export default function WaterPump() {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M26 21L26 11C26 9.89543 25.1046 9 24 9L7 9C5.89543 9 5 9.89543 5 11L5 21C5 22.1046 5.89543 23 7 23L24 23C25.1046 23 26 22.1046 26 21Z"
                stroke="black"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M29 18L29 14L26 14L26 18L29 18Z" stroke="black" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M23 9L23 7L18 7L18 9L23 9Z" stroke="black" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M25 7L25 5L16 5L16 7L25 7Z" stroke="black" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M22 23L22 9L8 9L8 23L22 23Z" stroke="black" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10 11.5L20 11.5" stroke="black" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10 14.5L20 14.5" stroke="black" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10 17.5L20 17.5" stroke="black" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10 20.5L20 20.5" stroke="black" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M6 27L24 27C24.5523 27 25 26.5523 25 26C25 25.4477 24.5523 25 24 25L6 25C5.44771 25 5 25.4477 5 26C5 26.5523 5.44771 27 6 27Z"
                stroke="black"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M22 25L22 23L8 23L8 25L22 25Z" stroke="black" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
